import { t } from '@/i18n/utils'

/**
 * Member 页面通用配置
 * 当前三端（rocnovel、oceread、ficmoon）文案一致
 */
export const memberCommonConfig = {
  texts: {
    get signIn() { return t('SignInButton') },
    get myWallet() { return t('MyWallet') },
    get coins() { return t('coins') },
    get topUp() { return t('TopUP') },
    get get() { return t('GetCoins1') },
    // 与 en.json 不完全匹配（'GET VIP Membership' vs 'Get VIP Membership'）
    get getVip() { return t('getVip') },
    get vipMembership() { return t('VIPMembership') },
    // 与 en.json 不完全匹配（'More coins,more benefits' 无空格）
    get moreCoinsMoreBenefits() { return t('moreCoinsMoreBenefits') },
    get expires() { return t('Expires') },
    get details() { return t('Details') },
    get transactionHistory() { return t('TransactionHistory') },
    get chaptersUnlocked() { return t('ChaptersUnlocked') },
    get contactUs() { return t('ContactUs') },
    get setting() { return t('Setting') },
    get guestName() { return t('Guest') },
    get guestTip() { return t('SignInToSyncLibrary') },
  },
}
